export default {
  title: 'Easy Air Screen',
  subtitle: 'Transformez votre tablette en second écran sans fil',
  description: 'Transformez votre tablette en un écran sans fil de haute qualité pour macOS. Élargissez votre espace de travail et boostez votre productivité—aucun câble nécessaire.',
  downloadMobile: 'Télécharger l\'Application Mobile',
  purchasePromise: 'Achat unique. Sans abonnement ni publicité.',
  companionPromise: 'L\'application Mac est gratuite et ne nécessite aucun compte.',
  downloadMacOS: 'Télécharger pour macOS (Universal)',
  quickSetup: 'Configuration Rapide',
  setupSteps: [
    'Installez Easy Air Screen sur votre tablette',
    'Téléchargez et installez l\'application de bureau pour macOS',
    'Connectez les deux appareils au même réseau Wi-Fi',
    'Lancez et connectez !'
  ],
  performanceTip: 'Conseil de Performance',
  performanceDescription: 'Pour la meilleure expérience avec un minimum de latence, utilisez une connexion Wi-Fi 5GHz sur les deux appareils. Si vous remarquez de la latence, essayez de réduire la résolution dans les paramètres de l\'application.',
  faqTitle: 'Questions fréquentes',
  faq: [
    {
      q: 'Quelle est la différence avec Sidecar ?',
      a: 'Easy Air Screen fonctionne même si les deux appareils utilisent des Apple ID différents. Vous pouvez aussi utiliser une tablette Android comme écran secondaire sans fil pour votre Mac.'
    },
    {
      q: 'Puis-je l’utiliser avec une tablette Android ?',
      a: 'Oui. Une tablette Android peut servir d’écran secondaire sans fil pour votre Mac. Connectez les deux appareils au même Wi-Fi pour étendre ou dupliquer l’écran.'
    },
    {
      q: 'Un iPhone peut-il devenir un écran secondaire ?',
      a: 'Oui. Un iPhone peut servir d’écran secondaire sans fil pour votre Mac. Lors de la connexion, choisissez l’extension du bureau ou la duplication de l’écran.'
    },
    {
      q: 'Est-ce une extension d’écran ou une duplication ?',
      a: 'Les deux sont possibles. Vous pouvez étendre le bureau de votre Mac sur un autre écran ou dupliquer l’écran actuel pour afficher la même image.'
    },
    {
      q: 'Une connexion internet est-elle nécessaire ? Mon écran sort-il du réseau ?',
      a: 'Non, aucune connexion internet n’est nécessaire. Les appareils se connectent directement sur le même Wi-Fi, sans passage ni stockage de l’écran sur un serveur externe.'
    },
    {
      q: 'Est-ce un abonnement ?',
      a: 'Non. L’appareil mobile s’achète une seule fois, sans abonnement ni publicité. L’app compagnon pour Mac est gratuite et ne demande aucun compte.'
    },
    {
      q: 'Est-ce que cela fonctionne sur un PC Windows ?',
      a: 'Non. Easy Air Screen est conçu uniquement pour macOS. Windows PC n’est pas pris en charge actuellement.'
    },
    {
      q: 'Que faire si l’écran est lent ou saccadé ?',
      a: 'Connectez les deux appareils à un réseau Wi-Fi 5GHz si possible. Si le délai persiste, réduisez la résolution dans les réglages de l’app.'
    },
  ]
};
